<pw-view-title>
  {{ 'change.change.changeManagement' | translate }}
</pw-view-title>

<mat-form-field>
  <input matInput type="text" [formControl]="filterControl" placeholder="Filter">
</mat-form-field>


<ng-container *ngIf="getRibbons().length > 0; else noProjects">
  <pw-ribbons #ribbonsComponent (ribbonClicked)="onRibbonClicked($event)">
    <ng-container *ngFor="let ribbon of getRibbons()">
      <pw-ribbon-item [title]="ribbon">
        <mat-button-toggle-group (change)="onButtonGroupChanged($event)" [multiple]="true"
                                 #group="matButtonToggleGroup">
          <mat-button-toggle [checked]="isToggleChecked(category)" *ngFor="let category of getCategories(ribbon)"
                             [value]="category">
            {{ category }}
          </mat-button-toggle>
        </mat-button-toggle-group>

        <div style="padding-top: 1rem">
          <app-pm-constructions-list
            [constructions]="constructionsForCategory || []"
            [filter]="filterControl.getRawValue()"></app-pm-constructions-list>
        </div>

      </pw-ribbon-item>
    </ng-container>
  </pw-ribbons>
</ng-container>


<ng-template #noProjects>
  <div>Es ist kein aktives Änderungsmanagement für den angemeldeten Lieferanten vorhanden!</div>
</ng-template>
